import React from "react";
import { LinkContainer } from "react-router-bootstrap";
import BannerImg from "../../assets/images/teach.svg";
import { Container, Row, Col, Image, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { instituteCheck } from "../../api/institute";

const HeroSection = () => {
  const { user } = useSelector((state) => ({ ...state }));
  const history = useHistory()

  const handleClick = e => {
    e.preventDefault();
    if (user && user.token) {
      instituteCheck(user._id, user.token)
        .then(res => {
          if (res.data.institute)
            history.push(`/admin/dashboard`)
          else
            history.push(`/add-my-institute`)
        })
        .catch(err => {
          toast.error(err.response ? err.response.data : 'There some error please try again later')
        })
    } else {
      toast.error('Please login first')
      history.push(`/login`)
    }
  }
  return (
    <div className="hero-banner section_padding">
      <Container>
        <Row className="align-items-center">
          <Col md={6} sm={12}>
            <h1 className="banner-head">
              Teach and Learn <br />
              with <span className="head-color">School Scheduler</span>
            </h1>
            <p className="banner-text">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam
              maximus eu erat ac iaculis. Phasellus vel magna tincidunt, viverra
              nunc nec, tincidunt felis
            </p>
            <div className="mt-4">
              <LinkContainer to='/' onClick={handleClick}>
                <Button>GET STARTED</Button>
              </LinkContainer>
            </div>
          </Col>
          <Col md={6} sm={12}>
            <Image src={BannerImg} className="img-fluid" />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default HeroSection;
